export class WelcomeModel {
  constructor() {
    this.authorName = "Terri Bowman";
    this.authorDesignation = "Founder, Blissiree";
    this.video = "https://www.youtube.com/embed/BXQpKtXqImc";
    this.image = "";
    this.googleForm = "";
  }
}
